import { Injectable } from '@angular/core';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  private categories;
  constructor(private requestService: RequestService) { }

  /** Set categories into service varaible.
  * @param data Categories object
  */
  setCategories(data) {
    this.categories = data;
  }

  /** Get categories from the platform.  */
  getCategories() {
    let req = {
      url: "/api/content/getCategories",
      req: {
        "type": 0
      }
    };
    return this.requestService.mainPostRequest(req);
  }

  /** Return category path name e.g. On Demand / Action.
  * @param nodeId Category id to map
  */
  getCategoryPath(nodeId) {
    const path = this._searchTree(nodeId, { categories: this.categories });
    let finalPath;
    if (path) {
      finalPath = new Array();
      path.forEach((obj, pos) => {
        //finalPath += obj.name + (pos == path.length - 1 ? "" : " / ")
        finalPath.push({
          id: obj.id,
          name: obj.name,
          isCurrent: pos == path.length - 1
        })
      });
    }
    return finalPath;
  }

  /** Search the object and return the path. Recurrent method.
  * @param nodeId Category id to map 
  * @param parent Categories to search into
  */
  _searchTree(nodeId, parent) {
    const stack = [[parent, []]];
    while (stack.length) {
      const [node, path] = stack.pop();
      if (node.id === nodeId) {
        return path;
      }
      if (node.categories) {
        stack.push(...node.categories.map((node, i) => [node, [...path, node]]));
      }
    }
  }
}